$bog_ui_toast $mol_view
	message \
	type \info
	closeable true
	close? null
	sub /
		<= Icon $mol_icon_information
		<= Body $mol_view
			sub /
				<= message
		<= Close $mol_button_minor
			click? <=> close?
			sub /
				<= Close_icon $mol_icon_close
	attr *
		bog_ui_toast_type <= type
		bog_ui_toast_closeable <= closeable
